import React from 'react';
import PropTypes from 'prop-types';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { formDataFromServerShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
// import {
//   isStatusScheduled,
//   isStatusCompleted,
//   isStatusImplementation,
// } from 'AppSrc/core/crq/crq-statuses';
import { InComsSent } from './comms-constants';
import {
  TAB_SECTION_SUMMARY,
  TAB_APPROVALS_HISTORY,
  TAB_COMPLETION_REVIEW,
  TAB_COMMS_SUMMARY,
} from './view-crq-constants';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-tabs.css';

const tabTitleMap = {
  [TAB_SECTION_SUMMARY]: 'CRQ Info',
  [TAB_APPROVALS_HISTORY]: 'Approvals History',
  [TAB_COMMS_SUMMARY]: 'Comms Summary',
  [TAB_COMPLETION_REVIEW]: 'Completion Review',
};

const ViewCrqTabs = ({
  openedTab,
  setTab,
  formData,
  network,
  showCrqAction,
  impactValue,
  commsStatusFlag,
  canViewCompletionReview,
}) => {

  const commsFlagValue = formData.commsStatusFlag;
  const otherLineOperatorValue = formData.otherLineOperator;

  const tabs = [
    TAB_SECTION_SUMMARY,
  ];

  if (formData.approvalHistory.length > 0) {
    tabs.push(TAB_APPROVALS_HISTORY);
  }
  // OLO CRQ
  if (commsFlagValue !== 'undefined' || commsFlagValue !== null) {
    const CheckComms = InComsSent.includes(commsFlagValue);
    if (formData.otherLineOperator === 'Yes' && CheckComms
    // && (
    //   isStatusCompleted(formData.status) || isStatusImplementation(formData.status) || isStatusScheduled(formData.status)
    // )
    ) {
      tabs.push(TAB_COMMS_SUMMARY);
    }
  }
  if (canViewCompletionReview) {
    tabs.push(TAB_COMPLETION_REVIEW);
  }

  // if (commsFlagValue !== 'undefined' || commsFlagValue !== null) {
  //   if ((network === 'fixed') && (otherLineOperatorValue !== 'Yes') && (impactValue === '1' || impactValue === '2') && ((commsFlagValue && commsFlagValue === 'InitialCommsSent') || (commsFlagValue && (commsFlagValue !== 'CommunicationNotRequired' && commsFlagValue !== 'InitialCommsReady')))) {
  //     tabs.push(TAB_COMMS_SUMMARY);
  //   }
  // }

  if (commsFlagValue !== 'undefined' || commsFlagValue !== null) {
    const CheckComms = InComsSent.includes(commsFlagValue);
    if ((network === 'fixed') && (otherLineOperatorValue !== 'Yes') && (impactValue === '1' || impactValue === '2') && CheckComms) {
      tabs.push(TAB_COMMS_SUMMARY);
    }
  }


  const baseClassName = 'view-crq-tabs';

  if (tabs.length < 2) {
    // we don't show if there is only one option but we do rely on the elements height to create a standard
    // space from the workflow bar
    return (
      <div className={`${baseClassName} ${baseClassName}-placeholder`} />
    );
  }

  return (
    <div className={baseClassName}>
      {
        tabs.map((tabId) => {
          const tabTitle = tabTitleMap[tabId];

          if (!tabTitle) {
            console.error(`Cannot find tab title for ${tabId}`);
          }

          return (
            <div
              className={`view-crq-tab view-crq-tab-${tabId === openedTab ? 'selected' : 'unselected'}`}
              key={tabId}
            >
              <OptionButton
                onClick={setTab}
                option={tabId}
              >
                <p className="tab-title">{tabTitle ? tabTitle : tabId}</p>
              </OptionButton>
            </div>
          );
        })
      }
    </div>
  );
};

ViewCrqTabs.propTypes = {
  openedTab: PropTypes.string,
  setTab: PropTypes.func,
  formData: formDataFromServerShape,
  canViewCompletionReview: PropTypes.bool,
  showCrqAction: PropTypes.bool,
  network: PropTypes.string,
  impactValue: PropTypes.string,
  commsStatusFlag: PropTypes.string,
};

export {
  ViewCrqTabs,
};

